import {
  HandHeart,
  Stethoscope,
  Home,
  Users,
  GraduationCap,
  Clock,
  HeartHandshake,
  Newspaper,
  Heart,
  BadgeCheck,
  MessageCircle,
  ShieldCheck,
} from "lucide-react";

const MAP = {
  HandHeart,
  Stethoscope,
  Home,
  Users,
  GraduationCap,
  Clock,
  HeartHandshake,
  Newspaper,
  Heart,
  BadgeCheck,
  MessageCircle,
  ShieldCheck,
};

// Icon-Helfer: rendert ein lucide-Icon anhand seines Namens
export const Icon = ({ name, className = "", strokeWidth = 1.75, ...props }) => {
  const Cmp = MAP[name] || Heart;
  return <Cmp className={className} strokeWidth={strokeWidth} aria-hidden="true" {...props} />;
};

export default Icon;
